const moment = require('moment-timezone');

export default {
  format(date) {
    return moment.tz(date, 'Europe/Brussels').format('MMM Do');
  },
};
